import  {useEffect, useState} from 'react';
import {
  Container,
  Box,
  Step,
  StepLabel,
  Stepper,
  Button,
  Typography,
  Grid
} from '@mui/material';
import $ from 'jquery';
import Loading from "../../Component/loading";

import Registration from './Registration';
import Voucher from './Voucher';
import { useApp } from '../../Contexts/AppProvider';
import { useRegister } from '../../Contexts/RegisterProvider';

const steps = [
  {
    label: '',
    description: <div style={{marginBottom: 40}}>
      <Grid container spacing={3}>
        <Grid item xl={12} lg={12} md={12} xs={12}>
          <img alt='card1' src={`assets/img/aviso.png`} style={{width: '100%'}} />
        </Grid>
        {/* <Grid item xl={12} lg={12} md={12} xs={12}>
          <img alt='card2' src={`assets/img/card2.png?${new Date().getTime()}`} style={{width: '100%'}} />
        </Grid>
        <Grid item xl={12} lg={12} md={12} xs={12}>
          <img alt='card3' src={`assets/img/card3.png?${new Date().getTime()}`} style={{width: '100%'}} />
        </Grid>
        <Grid item xl={12} lg={12} md={12} xs={12}>
          <img alt='card4' src={`assets/img/card4.png?${new Date().getTime()}`} style={{width: '100%'}} />
        </Grid>
        <Grid item xl={12} lg={12} md={12} xs={12}>
          <img alt='card5' src={`assets/img/card5.png?${new Date().getTime()}`} style={{width: '100%'}} />
        </Grid>
        <Grid item xl={12} lg={12} md={12} xs={12}>
          <img alt='card6' src={`assets/img/card6.png?${new Date().getTime()}`} style={{width: '100%'}} />
        </Grid> */}
      </Grid>
    </div>
  },
  {
    label: 'Planejamento n²',
    description: <div>Como parte do processo para receber seu crédito, devemos planejar como vamos usar esse dinheiro.<br />
    Preencha os campos abaixo para nossos Orientadores Financeiros ajudarem você no planejamento do seu negócio.</div>,
    page: Registration
  },
  {
    label: 'Cupom',
    page: Voucher
  }
];

export default function App() {
  const {setAlert} = useApp();
  const {sendRegister, data, setIsLoading, isLoading} = useRegister();
  const [activeStep, setActiveStep] = useState(0);
  const [disabledButtons, setDisabledButtons] = useState(false);

  const handleNext = async () => {
    try {
      setDisabledButtons(true);
      let disabled = false;

      $("div div[role='radiogroup']").each(function() {
        let radioGroupChecked = false;
        $(this).children().each(function() {
          if(!radioGroupChecked){
            radioGroupChecked = $(this).children().first().hasClass('Mui-checked');
          }   
        });

        if(!radioGroupChecked){
          $(this).prev().css("color", "#ff0000");
          disabled = true;
        }else{
          $(this).prev().attr('style', '');
        }
      })

      $('#formRegistration :input').each(function() {
        if(($(this).val() === "" || $(this).val() === "-1") && $(this)[0].tagName !== 'BUTTON'){
          $(this).parent('div').css("background", "#ff00002b");
          disabled = true;
        }else{
          $(this).parent('div').attr('style', '');
        }
      });

      setTimeout(async () => {
        if(!disabled) {
          const registerOk = activeStep === 1 ? await sendRegister() : true;
          registerOk && setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }else{
          setAlert({message: 'Por favor preencha todos os campos necessários', type: 'warning'});
          setTimeout(() => setAlert({message: '', type: 'warning'}), 6000);
        }
        setDisabledButtons(false);
      }, 500);
    } catch (error: any) {
      setIsLoading('');
      setDisabledButtons(false);
      if(error?.message){
        setAlert({message: error.message, type: 'warning'});
        setTimeout(() => setAlert({message: '', type: 'warning'}), 6000);
      }
    }
  };

  useEffect(() => {
    $('#formRegistration :input').each(function() {
      $(this).parent('div').attr('style', '');
      $(this).parent().parent().parent().prev().attr('style', '');
    });
  }, [data])

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const Page = steps[activeStep]?.page;

  return (
    <>
      <Box sx={{bgcolor: '#f7d800', textAlign: 'center'}}>
        <Grid container spacing={0}>
        <Grid item xl={3} lg={3} md={3} xs={12}>
          </Grid>
          {/* <Grid item xl={6} lg={6} md={6} xs={12} sx={{lineHeight: 0}}>
            <img alt='logos' style={{position: 'relative', width: '100%'}} src={`assets/img/logos.png?${new Date().getTime()}`} />
          </Grid>
          <Grid sx={{bgcolor: '#f7d800'}} item xl={3} lg={3} md={3} xs={12}>
          </Grid> */}
        </Grid>
      </Box>
      <Box>
        <Grid container spacing={0}>
          <Grid item xl={12} lg={12} md={12} xs={12}>
            <Container>
              <Box sx={styles.content}>
                <Box>
                  <Typography variant='h4'>{steps[activeStep]?.label}</Typography>
                  {steps[activeStep]?.description}
                  {Page && <Page />}
                </Box>
        
                {activeStep < steps.length-1 && (
                  <Box sx={{display: 'flex', justifyContent: 'space-between' }}>
                    {activeStep !== 0 && (
                      <Button disabled={disabledButtons} variant="contained" onClick={handleBack}>
                        Anterior
                      </Button>
                    )}

                    {/* <Button id='btnNext' disabled={disabledButtons} variant="contained" onClick={handleNext}>
                      Próximo
                    </Button>   */}
                  </Box>
                )}
              </Box>
            </Container>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Container>
          <Grid container spacing={0}>
            <Grid item xl={6} lg={6} md={6} xs={12} style={{display: 'flex', justifyContent: 'center'}}>
              <Typography variant='caption' color='#009fff' sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Copyright © 2022. n², Tecnologia e Informação LTDA. Todos os direitos reservados.</Typography>
            </Grid>

            <Grid item xl={6} lg={6} md={6} xs={12} sx={{textAlign: 'right'}}>
              <img style={{position: 'relative', height: 60}} src={`assets/img/powered.?${new Date().getTime()}`} alt='poewred' />
            </Grid>
          </Grid>
        </Container>
      </Box>
      {isLoading && <Loading text={isLoading} />}
    </>
  );
}

const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    p: 4,
    mb: 3,
    border: 'solid #eeeeee 0.6px',
    borderRadius: 7
  },
}